// src/seo/seoPages.js
// Titre, description et indexation de chaque page publique.
// Fichier sans import : il est utilisé par le hook useSEO (dans le navigateur)
// et par scripts/prerender.mjs (au build) pour générer le HTML statique de chaque page.

export const SITE_URL = "https://cyber-guard.fr";
export const SITE_NAME = "CyberGuard";

const seoPages = {
  "/": {
    title: "Test de sécurité de site web automatisé | CyberGuard",
    description:
      "Testez la sécurité de votre site en 2 minutes : certificat SSL, en-têtes HTTP, emails (SPF, DKIM, DMARC). Rapport clair et plan d'action. Dès 29 €/mois.",
  },
  "/blog": {
    title: "Blog cybersécurité pour PME | CyberGuard",
    description:
      "Conseils pratiques en cybersécurité pour les PME : phishing, RGPD, scan de vulnérabilités, sécurité des emails et du site web.",
  },
  "/cgv": {
    title: "Conditions générales d'utilisation | CyberGuard",
    description: "Conditions générales d'utilisation et de vente du service CyberGuard.",
  },
  "/mentions-legales": {
    title: "Mentions légales | CyberGuard",
    description: "Mentions légales du site cyber-guard.fr : éditeur, hébergement et contact.",
  },
  "/confidentialite": {
    title: "Politique de confidentialité | CyberGuard",
    description:
      "Comment CyberGuard collecte, stocke et protège vos données personnelles, et liste de nos sous-traitants.",
  },
  "/login": {
    title: "Connexion | CyberGuard",
    description: "Connectez-vous à votre espace CyberGuard.",
    noindex: true,
  },
  "/register": {
    title: "Créer un compte | CyberGuard",
    description: "Créez votre compte CyberGuard et lancez votre premier audit de sécurité.",
    noindex: true,
  },
};

export default seoPages;
